export { KmapSolvee } from './KmapSolvee';
